import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { requireMe } from "../../features/auth/guard";
import { ConnectExtension } from "../../features/extension/components/connect-extension";

/** FR-EXT-03: /extension/connect?extension=<chrome extension id>, opened by the extension. */
export const Route = createFileRoute("/extension/connect")({
  validateSearch: z.object({ extension: z.string().optional().catch(undefined) }),
  beforeLoad: async ({ context, location }) => {
    await requireMe(context.queryClient, location.href);
  },
  component: () => <ConnectExtension extensionId={Route.useSearch().extension} />,
});
